<template>
    <details class="vchy-language-selector" v-vch-accordion ref="dropdown">
    <summary id="LANGUAGE_SELECTOR" ref="accordion">
      <h2 class="text-small-em">{{ selectedCountry }}</h2>
      <svg
        class="vchy-language-selector__toggle"
        aria-hidden="true"
        width="24"
        height="24"
      >
        <use href="/assets/sprite/icons.svg#arrow-black"></use>
      </svg>
    </summary>
    <div
      class="vchy-details__contents"
      aria-labelledby="LANGUAGE_SELECTOR"
    >
      <ul class="vchy-language-selector__list pt-xs">
        <li v-for="country in countriesList"
            v-if="country.LanguageCode!=selectedCountry"
            :value="country.LanguageCode"
            :key="country.LanguageCode"
            role="option"
            tabindex="0"
            @keypress.space="selectOption(country)"
            @keypress.enter="selectOption(country)">
          <a :href="country.Url" class="text-small-em"> {{ country.LanguageCode }}</a>
        </li>
      </ul>
    </div>
  </details>


</template>

<script>
export default {
props: {
  countriesList : {
      type: Array,
      required: true,
    }, 
  baseUrl : {
      type: String,
      required: true,
    },
  defaultOption: {
      type: String,
      required: true,
    },
},

  data() {
    return {
      selectedCountry: this.defaultOption,
    };
    this.selectOnLoad();
    this.closeListOnLoad();
  },
 
  methods: {
    handleClickOutside(event) {
      if (!this.$refs.dropdown.contains(event.target)) {
        this.$refs.dropdown.removeAttribute('open');
      }
    }
  },
  closeDropdown() {
    let detailsTag = document.querySelector('.vchy-language-selector');
        if (detailsTag && detailsTag.tagName.toLowerCase() === 'details') {
          detailsTag.removeAttribute('open');
        }
  },
  selectOnLoad() {
      setTimeout(function () {
        if (
          document.querySelector(
            '.vchy-language-selector__list [aria-selected]'
          )
        ) {
          document
            .querySelector('.vchy-language-selector__list [aria-selected]')
            .click();
        }
      }, 200);
    },
    closeListOnLoad() {
      setTimeout(function () {
        closeDropdown();
      }, 1000);
    },
    mounted () {
    document.addEventListener('click',  this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style lang="scss" src="./language-selector.scss"></style>
